module.exports = __webpack_public_path__ + "static/media/logo-print.36eccbcd.png";